import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 3.75C3.70435 3.75 2.94129 4.06607 2.37868 4.62868C1.81607 5.19129 1.5 5.95435 1.5 6.75V7.5H22.5V6.75C22.5 5.95435 22.1839 5.19129 21.6213 4.62868C21.0587 4.06607 20.2956 3.75 19.5 3.75H4.5Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5 9.75H1.5V17.25C1.5 18.0456 1.81607 18.8087 2.37868 19.3713C2.94129 19.9339 3.70435 20.25 4.5 20.25H19.5C20.2956 20.25 21.0587 19.9339 21.6213 19.3713C22.1839 18.8087 22.5 18.0456 22.5 17.25V9.75ZM4.5 13.5C4.5 13.3011 4.57902 13.1103 4.71967 12.9697C4.86032 12.829 5.05109 12.75 5.25 12.75H11.25C11.4489 12.75 11.6397 12.829 11.7803 12.9697C11.921 13.1103 12 13.3011 12 13.5C12 13.6989 11.921 13.8897 11.7803 14.0303C11.6397 14.171 11.4489 14.25 11.25 14.25H5.25C5.05109 14.25 4.86032 14.171 4.71967 14.0303C4.57902 13.8897 4.5 13.6989 4.5 13.5ZM5.25 15.75C5.05109 15.75 4.86032 15.829 4.71967 15.9697C4.57902 16.1103 4.5 16.3011 4.5 16.5C4.5 16.6989 4.57902 16.8897 4.71967 17.0303C4.86032 17.171 5.05109 17.25 5.25 17.25H8.25C8.44891 17.25 8.63968 17.171 8.78033 17.0303C8.92098 16.8897 9 16.6989 9 16.5C9 16.3011 8.92098 16.1103 8.78033 15.9697C8.63968 15.829 8.44891 15.75 8.25 15.75H5.25Z"
        fill={colorValue}
      />
    </svg>
  );
};
